import { carRentalService } from '@/api/services';

function normalizeLocationRows(rows, fallbackType) {
  if (!Array.isArray(rows)) return [];
  return rows
    .filter((row) => row && typeof row === 'object')
    .map((row) => {
      const idRaw = row.id;
      const idNum = Number(idRaw);
      const id = Number.isFinite(idNum) && idNum > 0 ? idNum : null;
      const name = String(row.name || '').trim();
      if (!id || !name) return null;
      const destinationName = String(row.destination_name || '').trim();
      const regionName = String(row.region_name || '').trim();
      return {
        ...row,
        type: String(row.type || fallbackType || '').trim() || fallbackType,
        id,
        name,
        destination_name: destinationName || null,
        region_name: regionName || null,
      };
    })
    .filter(Boolean);
}

function extractLocationPayload(response) {
  const top = response?.data;
  const data = top?.data;
  const obj = (data && typeof data === 'object' && !Array.isArray(data))
    ? data
    : (top && typeof top === 'object' && !Array.isArray(top) ? top : {});
  return {
    hotels: normalizeLocationRows(obj.hotels, 'hotel'),
    places: normalizeLocationRows(obj.places, 'place'),
  };
}

let memory = null;
let inflight = null;

export function peekCarRentalLocations() {
  return memory;
}

export function loadCarRentalLocations() {
  if (memory) return Promise.resolve(memory);
  if (!inflight) {
    inflight = carRentalService.getLocations()
      .then((res) => {
        memory = extractLocationPayload(res);
        return memory;
      })
      .catch((err) => {
        memory = null;
        throw err;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}
